// Contract for the joinGroup / resolveInviteCode / rotateGroupInviteCode callables. Joining a group is
// server-side so membership always needs proof the caller was invited — the
// group doc's rules no longer let a client add itself.

/**
 * Exactly one proof is required, except `groupId` alone, which only succeeds
 * when the caller is already a guest of that group (the post-sign-in upgrade).
 * `groupId` may accompany `code` / `inviteId` to pin which group is expected.
 */
export interface JoinGroupRequest {
  groupId?: string
  /** A group's invite code, from a /join/:code link. */
  code?: string
  /** A share-link invite (`invites/{id}`, kind 'group'). */
  inviteId?: string
  /** A direct friend-to-group invite (`groupInvites/{id}`) addressed to the caller. */
  groupInviteId?: string
}

/**
 * Anonymous callers are added to `guestIds` (preview access), real accounts to
 * `memberIds`. `alreadyMember` means nothing changed.
 */
export interface JoinGroupResult {
  groupId: string
  role: 'member' | 'guest'
  alreadyMember: boolean
}

export interface InviteCodePreview {
  id: string
  name: string
  imageUrl?: string
  isMember: boolean
}

export interface ResolveInviteCodeResult {
  group: InviteCodePreview | null
}

export const MAX_GROUP_MEMBERS = 200

export interface RotateInviteCodeRequest {
  groupId: string
}

export interface RotateInviteCodeResult {
  inviteCode: string
}

export function generateInviteCode(): string {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
  return Array.from({ length: 6 }, () => chars[Math.floor(Math.random() * chars.length)]).join('')
}
